<template>
  <a-layout class="dd-layout">
    <a-layout-header>
      <Header parent="manage"></Header>
      <!-- <a-row>
        <a-col
          :span="10"
          style="font-size: 22px;font-family: FZLanTingHei-R-GBK;font-weight: 400;color: #FFFFFF;"
        >
          <img
            src="../assets/logo.svg"
            style="width:32px;height:32px;margin-right:10px;"
          />
          测绘所房屋管理系统
        </a-col>
        <a-col
          :span="12"
          class="dd-rowback"
        >
          <a-icon
            type="rollback"
            @click="2"
          /><span @click="$router.push('/home')">&nbsp;&nbsp;返回首页</span>
        </a-col>
        <a-col
          :span="2"
          style="color:rgba(255, 255, 255, 0.65);"
        >
          <a-divider type="vertical" />
          <a-dropdown>
            <a
              class="ant-dropdown-link"
              @click="e => e.preventDefault()"
            >
              <a-button
                shape="circle"
                icon="user"
                class="dd-user-icon"
              />
              <span class="dd-user-name">
                {{this.$store.state.user.name}}
              </span>
              <a-icon type="caret-down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item
                key="0"
                @click="logout"
              >退出
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </a-col>
      </a-row> -->
    </a-layout-header>
    <a-layout-content style="padding: 50px 100px">
      <a-tabs
        class="dd-tabs"
        type="card"
        @change="tabChange"
        :tab-position="'left'"
        :tabBarStyle="{width:'200px',border:'none'}"
        :tabBarGutter="0"
      >
        <a-tab-pane key="1">
          <span slot="tab">
            <a-icon type="deployment-unit" />
            数据管理
          </span>
          <div style="text-align:right;margin-bottom:10px;">
            <a-button
              type="primary"
              @click="addLayer"
            >新增</a-button>
          </div>
          <a-table
            :columns="dataColumns"
            :data-source="dataData"
            :pagination="false"
            :custom-row="rowClick"
          >
            <span
              slot="geometry_type"
              slot-scope="geomType"
            >{{getFormat(geomType)}}</span>
            <div
              slot="action"
              slot-scope="text, record"
            >
              <a-button
                type="primary"
                size="small"
                @click="editLayer(record)"
              >编辑</a-button>
              <a-button
                v-show="record.type=='矢量'&&record.layer"
                type="primary"
                size="small"
                style="margin-left:10px"
                @click="setStyle(record)"
              >设置样式</a-button>
              <a-button
                v-show="record.type=='矢量'&&record.layer"
                type="primary"
                size="small"
                style="margin-left:10px"
                @click="uploadAttach(record)"
              >照片附件</a-button>
              <a-button
                v-show="false"
                type="primary"
                size="small"
                style="margin-left:10px"
                @click="setBaseMap(record)"
              >{{record.is_basemap=='1'?'取消底图':'设为底图'}}</a-button>
              <a-button
                v-show="record.type=='矢量'&&record.layer"
                type="primary"
                size="small"
                style="margin-left:10px"
                @click="fieldMap(record)"
              >字段映射</a-button>
              <a-popconfirm
                title="确认要删除吗?"
                cancelText="取消"
                okText="确认"
                @confirm="() => deleteRow(record)"
              >
                <a-button
                  type="danger"
                  size="small"
                  style="margin-left:10px"
                >删除</a-button>
              </a-popconfirm>
            </div>
          </a-table>
          <a-modal
            v-model="fieldMapVisible"
            title="字段映射"
            @ok="saveFieldMap"
            :maskClosable="false"
            cancelText="取消"
            okText="确定"
          >
            <a-table
              :columns="[{title:'字段名称',dataIndex:'o_field'},{title:'显示名称',dataIndex:'n_field',scopedSlots:{customRender:'fieldName'}},{   title: '是否显示', dataIndex: 'show',scopedSlots:{ customRender: 'controlShow'}}]"
              :data-source="fieldMapData"
              :pagination="false"
              :size="'small'"
              :custom-row="rowClick"
            >
              <a-input
                slot="fieldName"
                slot-scope="text,record"
                type="text"
                autocomplete="off"
                @change="nFieldChange($event,record)"
                :value="text"
              >
              </a-input>
              <a-switch
                default-checked
                slot="controlShow"
                slot-scope="text, record"
                :checked="record.show=='1'"
                @change="onFieldShowChange($event,record)"
              />
            </a-table>
          </a-modal>
          <a-modal
            v-model="dataModalVisible"
            :title="groupForm.id?'编辑数据':'新增数据'"
            @ok="addLayerHandle"
            :maskClosable="false"
            cancelText="取消"
            okText="确定"
          >
            <div>
              <a-form-model
                ref="groupForm"
                :model="groupForm"
                :labelCol="{span:6}"
                :wrapperCol="{span:10}"
                :rules="groupRules"
              >
                <a-form-model-item
                  has-feedback
                  label="数据类型"
                  prop="type"
                >
                  <a-select
                    :disabled="groupForm.id!=null"
                    default-value="分组"
                    v-model="groupForm.type"
                    @change="handleChange"
                  >
                    <a-select-option value="分组">
                      分组
                    </a-select-option>
                    <a-select-option value="矢量">
                      矢量
                    </a-select-option>
                    <a-select-option value="栅格">
                      栅格
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item
                  label="所属分组"
                  prop="group_id"
                  v-show="groupForm.type!='分组'"
                >
                  <a-select
                    :options="groupNameOptions"
                    v-model="groupForm.group_id"
                  >
                  </a-select>
                </a-form-model-item>
                <a-form-model-item
                  has-feedback
                  :label="layerNameLabel"
                  prop="name"
                >
                  <a-input
                    v-model="groupForm.name"
                    type="text"
                    autocomplete="off"
                  >
                  </a-input>
                </a-form-model-item>
                <a-form-model-item
                  has-feedback
                  :label="'左下角X'"
                  prop="leftX"
                  v-show="groupForm.type=='栅格'"
                >
                  <a-input
                    v-model="groupForm.leftX"
                    type="text"
                    autocomplete="off"
                  >
                  </a-input>
                </a-form-model-item>
                <a-form-model-item
                  has-feedback
                  :label="'左下角Y'"
                  prop="leftY"
                  v-show="groupForm.type=='栅格'"
                >
                  <a-input
                    v-model="groupForm.leftY"
                    type="text"
                    autocomplete="off"
                  >
                  </a-input>
                </a-form-model-item>
                <a-form-model-item
                  has-feedback
                  :label="'右上角X'"
                  prop="rightX"
                  v-show="groupForm.type=='栅格'"
                >
                  <a-input
                    v-model="groupForm.rightX"
                    type="text"
                    autocomplete="off"
                  >
                  </a-input>
                </a-form-model-item>
                <a-form-model-item
                  has-feedback
                  :label="'右上角Y'"
                  prop="rightY"
                  v-show="groupForm.type=='栅格'"
                >
                  <a-input
                    v-model="groupForm.rightY"
                    type="text"
                    autocomplete="off"
                  >
                  </a-input>
                </a-form-model-item>
              </a-form-model>
              <a-upload-dragger
                v-show="groupForm.type!='分组'"
                :accept="groupForm.type=='矢量'?'.zip':'.geotiff,.tif,.tiff,.png,.jpg,jpeg'"
                name="file"
                :file-list="uploadFileList"
                :multiple="false"
                :action="groupForm.type=='矢量'?'zserver/api/upload_vectors':'zserver/api/upload_raster'"
                :headers="uploadHeader"
                @change="uploadStatusChange"
              >
                <p class="ant-upload-drag-icon">
                  <a-icon type="inbox" />
                </p>
                <p class="ant-upload-text">
                  点击或将文件拖拽到这里上传
                </p>
                <p
                  class="ant-upload-hint"
                  v-show="groupForm.type=='矢量'"
                >
                  支持扩展名：.zip（shp图层文件打包后上传）
                </p>
                <p
                  class="ant-upload-hint"
                  v-show="groupForm.type=='栅格'"
                >
                  支持扩展名：.geotiff,.tif,.tiff,.png,.jpg(.jpeg)
                </p>
              </a-upload-dragger>
            </div>
          </a-modal>
          <a-modal
            v-model="attachModalVisible"
            title="上传照片附件"
            :maskClosable="false"
            :footer="null"
          >
            <a-upload-dragger
              :accept="'.zip'"
              name="file"
              :multiple="false"
              :action="'zserver/api/upload_attach'"
              :headers="uploadHeader"
              :data="{layer:attachLayerKey}"
              @change="uploadAttachStatusChange"
            >
              <p class="ant-upload-drag-icon">
                <a-icon type="inbox" />
              </p>
              <p class="ant-upload-text">
                点击或将文件拖拽到这里上传
              </p>
              <p class="ant-upload-hint">
                支持扩展名：.zip（以地块编号为名建立文件夹，将对应的照片放在文件夹下，最终将所有文件夹打zip包上传，注意打包时不要嵌套两层）
              </p>
            </a-upload-dragger>
          </a-modal>
          <style-setting ref="styleSettingC"></style-setting>
        </a-tab-pane>
        <a-tab-pane key="2">
          <span slot="tab">
            <a-icon type="user-add" />
            用户管理
          </span>
          <div style="text-align:right;margin-bottom:10px;">
            <a-button
              type="primary"
              @click="userModalVisible=true"
            >新增</a-button>
          </div>
          <a-table
            :columns="userColumns"
            :data-source="userData"
            :pagination="false"
            :custom-row="rowClick"
            rowKey="id"
          >
            <div
              slot="action"
              slot-scope="text, record"
              v-show="record.login!='admin'"
            >
              <a-button
                type="primary"
                size="small"
                @click="editUser(record)"
              >编辑</a-button>
              <a-popconfirm
                title="确认要删除吗?"
                cancelText="取消"
                okText="确认"
                @confirm="() => deleteUser(record)"
              >
                <a-button
                  type="danger"
                  size="small"
                  style="margin-left:10px"
                >删除</a-button>
              </a-popconfirm>
            </div>
          </a-table>
          <a-modal
            v-model="userModalVisible"
            title="新增用户"
            @ok="addUserHandle"
            @cancel="cancelUserHandle"
            :maskClosable="false"
            cancelText="取消"
            okText="确定"
          >
            <a-form-model
              ref="userForm"
              :model="userForm"
              :labelCol="{span:6}"
              :wrapperCol="{span:12}"
              :rules="userRules"
            >
              <a-form-model-item
                has-feedback
                label="用户名"
                prop="name"
              >
                <a-input
                  v-model="userForm.name"
                  type="text"
                  autocomplete="off"
                >
                </a-input>
              </a-form-model-item>
              <a-form-model-item
                has-feedback
                label="登录名"
                prop="login"
              >
                <a-input
                  v-model="userForm.login"
                  type="text"
                  autocomplete="off"
                  :disabled="userForm.id!=''&&userForm.id!=null"
                >
                </a-input>
              </a-form-model-item>
              <a-form-model-item
                has-feedback
                label="密码"
                prop="password"
              >
                <a-input
                  v-model="userForm.password"
                  type="password"
                  autocomplete="off"
                >
                </a-input>
              </a-form-model-item>
              <a-form-model-item
                has-feedback
                label="确认密码"
                prop="checkPass"
              >
                <a-input
                  v-model="userForm.checkPass"
                  type="password"
                  autocomplete="off"
                >
                </a-input>
              </a-form-model-item>
              <a-form-model-item
                has-feedback
                label="所属机构"
                prop="org_name"
              >
                <a-input
                  v-model="userForm.org_name"
                  type="text"
                  autocomplete="off"
                >
                </a-input>
              </a-form-model-item>
              <a-form-model-item
                has-feedback
                label="机构编码"
                prop="org_no"
              >
                <a-input
                  v-model="userForm.org_no"
                  type="text"
                  autocomplete="off"
                >
                </a-input>
              </a-form-model-item>
              <a-form-model-item
                has-feedback
                label="所属角色"
                prop="role_no"
              >
                <a-select
                  :options="rolesOptions"
                  v-model="userForm.role_no"
                >
                </a-select>
              </a-form-model-item>
            </a-form-model>
          </a-modal>
        </a-tab-pane>
        <a-tab-pane key="3">
          <span slot="tab">
            <a-icon type="team" />
            角色管理
          </span>
          <div style="text-align:right;margin-bottom:10px;">
            <a-button
              type="primary"
              @click="roleModalVisible=true"
            >新增</a-button>
          </div>
          <a-table
            :columns="[{title:'角色名称',dataIndex:'role_name'},{title:'角色编号',dataIndex:'role_no'},{   title: '操作', dataIndex: 'action',scopedSlots:{ customRender: 'action'}}]"
            :data-source="roleData"
            :pagination="false"
            :custom-row="rowClick"
            rowKey="id"
          >
            <div
              slot="action"
              slot-scope="text, record"
            >
              <a-button
                type="primary"
                size="small"
                @click="editRole(record)"
              >编辑</a-button>
              <a-popconfirm
                title="确认要删除吗?"
                cancelText="取消"
                okText="确认"
                @confirm="() => deleteRole(record)"
              >
                <a-button
                  type="danger"
                  size="small"
                  style="margin-left:10px"
                >删除</a-button>
              </a-popconfirm>
            </div>
          </a-table>
          <a-modal
            v-model="roleModalVisible"
            title="新增角色"
            @ok="addRoleHandle"
            @cancel="cancelRoleHandle"
            :maskClosable="false"
            cancelText="取消"
            okText="确定"
          >
            <a-form-model
              ref="roleForm"
              :model="roleForm"
              :labelCol="{span:6}"
              :wrapperCol="{span:12}"
              :rules="roleRules"
            >
              <a-form-model-item
                has-feedback
                label="角色名称"
                prop="role_name"
              >
                <a-input
                  v-model="roleForm.role_name"
                  type="text"
                  autocomplete="off"
                >
                </a-input>
              </a-form-model-item>
              <a-form-model-item
                has-feedback
                label="角色编号"
                prop="role_no"
              >
                <a-input
                  v-model="roleForm.role_no"
                  type="text"
                  autocomplete="off"
                >
                </a-input>
              </a-form-model-item>
            </a-form-model>
          </a-modal>
        </a-tab-pane>

        <!-- <a-tab-pane key="4">
          <span slot="tab">
            <a-icon type="team" />
            首页简介
          </span>
          <div style="text-align:right;margin-bottom:10px;">
            <a-button
              type="primary"
              @click="abstractModalVisible=true"
            >新增</a-button>
          </div>
          <a-table
            :columns="[{width:'100px', title:'机构编码',dataIndex:'org_no'},{title:'简介内容',dataIndex:'content'},{ width:'200px',  title: '操作', dataIndex: 'action',scopedSlots:{ customRender: 'action'}}]"
            :data-source="abstractData"
            :pagination="false"
            :custom-row="rowClick"
            rowKey="id"
          >
            <div
              slot="action"
              slot-scope="text, record"
            >
              <a-button
                type="primary"
                size="small"
                @click="editAbstract(record)"
              >编辑</a-button>
              <a-popconfirm
                title="确认要删除吗?"
                cancelText="取消"
                okText="确认"
                @confirm="() => deleteAbstract(record)"
              >
                <a-button
                  type="danger"
                  size="small"
                  style="margin-left:10px"
                >删除</a-button>
              </a-popconfirm>
            </div>
          </a-table>
          <a-modal
            v-model="abstractModalVisible"
            title="新增/编辑首页简介"
            @ok="addAbstractHandle"
            @cancel="cancelAbstractHandle"
            :maskClosable="false"
            cancelText="取消"
            okText="确定"
          >
            <a-form-model
              ref="abstractForm"
              :model="abstractForm"
              :labelCol="{span:6}"
              :wrapperCol="{span:18}"
              :rules="abstractRules"
            >
              <a-form-model-item
                has-feedback
                label="简介内容"
                prop="content"
              >
                <a-textarea v-model="abstractForm.content">
                </a-textarea>
              </a-form-model-item>
            </a-form-model>
          </a-modal>
        </a-tab-pane> -->
        <a-tab-pane key="4">
          <span slot="tab">
            <a-icon type="team" />
            首页设置
          </span>
          <div style="text-align:right;margin-bottom:10px;">
            <a-button
              type="primary"
              @click="saveHomeSetting"
            >保存</a-button>
          </div>
          <a-form-model
            ref="abstractForm"
            :model="abstractForm"
            :labelCol="{span:4}"
            :wrapperCol="{span:20}"
            :rules="abstractRules"
          >
            <a-form-model-item
              has-feedback
              label="乡镇简介"
              prop="content"
            >
              <a-textarea
                v-model="abstractForm.content"
                :rows="8"
              >
              </a-textarea>
            </a-form-model-item>
            <a-form-model-item
              has-feedback
              label="镇域基本农田关联图层"
              prop="jbnt"
            >
              <a-select
                show-search
                :options="attrCanSearchLayerList"
                placeholder="选择关联图层"
                style="width: 300px"
                v-model="abstractForm.jbnt"
              >
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              has-feedback
              label="镇域土地现状分布关联图层"
              prop="tdxz"
            >
              <a-select
                show-search
                :options="attrCanSearchLayerList"
                placeholder="选择关联图层"
                style="width: 300px"
                v-model="abstractForm.tdxz"
              >
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              has-feedback
              label="造林绿化分布关联图层"
              prop="zllh"
            >
              <a-select
                show-search
                :options="attrCanSearchLayerList"
                placeholder="选择关联图层"
                style="width: 300px"
                v-model="abstractForm.zllh"
              >
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              has-feedback
              label="集建地项目关联图层"
              prop="jjd"
            >
              <a-select
                show-search
                :options="attrCanSearchLayerList"
                placeholder="选择关联图层"
                style="width: 300px"
                v-model="abstractForm.jjd"
              >
              </a-select>
            </a-form-model-item>
          </a-form-model>
        </a-tab-pane>
        <a-tab-pane key="5">
          <span slot="tab">
            <a-icon type="unordered-list" />
            系统日志
          </span>
          <a-row style="text-align:right;margin-bottom:10px;line-height:32px;">
            <a-col :span="3">
              操作内容
            </a-col>
            <a-col :span="4">
              <a-select
                show-search
                :options="operationOptions"
                placeholder="选择操作"
                style="width: 200px"
                v-model="logSearchParam.selectedLogOperation"
              >
              </a-select>
            </a-col>
            <a-col :span="3">
              开始时间
            </a-col>
            <a-col :span="4">
              <a-date-picker
                show-time
                format="YYYY-MM-DD HH:mm:ss"
                placeholder="开始"
                v-model="logSearchParam.startTime"
              />
            </a-col>
            <a-col :span="3">
              结束时间
            </a-col>
            <a-col :span="4">
              <a-date-picker
                show-time
                format="YYYY-MM-DD HH:mm:ss"
                placeholder="结束"
                v-model="logSearchParam.endTime"
              />
            </a-col>
            <a-col :span="3">
              <a-button
                type="primary"
                style="margin-right:5px;"
                @click="searchLogs"
              >查询</a-button>
              <a-button
                type="primary"
                @click="resetLogParams"
              >重置</a-button>
            </a-col>

          </a-row>
          <a-table
            :columns="[{title:'用户',dataIndex:'login'},{title:'用户名',dataIndex:'user_name'},{title:'访问IP',dataIndex:'ip'},{  title: '操作内容', dataIndex: 'operation'},{  title: '时间', dataIndex: 'i_time'}]"
            :data-source="LogData"
            :pagination="logPagination"
            @change="logPageChage"
            rowKey="id"
          >
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-layout-content>
  </a-layout>
</template>

<script>
import dbTool from "../utils/localDb";
import StyleSetting from '../components/StyleSetting.vue';
import Header from '../components/Header';
import moment from 'moment'//导入文件

export default {
  components: { StyleSetting, Header },
  name: "Manage",
  data() {
    return {
      attrCanSearchLayerList: [],
      dataColumns: [
        {
          title: "名称",
          dataIndex: "title",
          key: "title"
        },
        {
          title: "类型",
          dataIndex: "type",
          key: "type",
        },
        {
          title: "格式",
          dataIndex: "geometry_type",
          key: "geometry_type",
          scopedSlots: { customRender: "geometry_type" }
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" }
        }
      ],
      dataData: [],
      userColumns: [
        {
          title: "用户名",
          dataIndex: "name",
          key: "name"
        },
        {
          title: "登录名",
          dataIndex: "login",
          key: "login"
        },
        {
          title: "所属机构",
          dataIndex: "org_name",
          key: "org_name"
        },
        {
          title: "机构编码",
          dataIndex: "org_no",
          key: "org_no"
        },
        {
          title: "操作",
          dataIndex: "action",
          key: "action",
          scopedSlots: { customRender: "action" }
        }
      ],
      userData: [],
      LogData: [],
      operationOptions: [],
      logSearchParam: {
        selectedLogOperation: undefined,
        startTime: "",
        endTime: ""
      },
      logPagination: {},
      abstractData: [],
      dataModalVisible: false,
      fieldMapVisible: false,
      fieldMapData: [],
      attachModalVisible: false,
      attachLayerKey: "",
      abstractModalVisible: false,
      userModalVisible: false,
      roleModalVisible: false,
      groupNameOptions: [],
      layerNameLabel: "分组名称",
      uploadFileList: [],
      groupForm: {
        id: null,
        type: "分组",
        name: "",
        group_id: null,
        layer: "",
        center: "",
        leftX: "",
        leftY: "",
        rightX: "",
        rightY: "",
        bbox: "",
        geometry_type: "",
        create_by: this.$store.state.user.login,
        visible: "-1"
      },
      groupRules: {
        name: [{ required: true, message: '名称必须填写', trigger: 'blur' }, { validator: this.nameRepeatValid, message: "名称不能重复，请更换其他名称" }],
        leftX: [{ pattern: /^[0-9.]*$/, message: "必须输入数字" }, { validator: this.xyValid }],
        leftY: [{ pattern: /^[0-9.]*$/, message: "必须输入数字" }, { validator: this.xyValid }],
        rightX: [{ pattern: /^[0-9.]*$/, message: "必须输入数字" }, { validator: this.xyValid }],
        rightY: [{ pattern: /^[0-9.]*$/, message: "必须输入数字" }, { validator: this.xyValid }],
      },
      userForm: {
        id: null,
        name: "",
        login: "",
        password: "",
        checkPass: "",
        org_name: "",
        org_no: "",
        role_no: ""
      },
      userRules: {
        name: [{ required: true, message: '用户名必须填写', trigger: 'blur' }],
        login: [{ required: true, message: '登录名必须填写', trigger: 'blur' }, { pattern: /^[a-zA-Z][a-zA-Z0-9_]*$/, message: "必须输入字母或数字且以字母开头" }, { validator: this.validateLoginExist }],
        password: [{ required: true, validator: this.validatePass, trigger: 'change' }, { pattern: /^[a-zA-Z].*[0-9]|[0-9].*[a-zA-Z]$/, message: "必须输入字母和数字" }],
        checkPass: [{ required: true, validator: this.validatePass2, trigger: 'change' }],
        role_no: [{ required: true, message: '必须设置角色', trigger: 'blur' }],
      },
      rolesOptions: [{ label: "管理者", value: "002" }, { label: "普通用户", value: "003" }],
      roleForm: {
        id: null,
        role_name: "",
        role_no: ""
      },
      roleRules: {
        role_name: [{ required: true, message: '角色名称必须填写', trigger: 'blur' }],
        role_no: [{ required: true, message: '角色编号必须填写', trigger: 'blur' }]
      },
      roleData: [],
      uploadHeader: { authorization: this.$store.state.token },
      abstractForm: {
        org_no: this.$store.state.user.org_no,
        content: "",
        jbnt: undefined,
        tdxz: undefined,
        zllh: undefined,
        jjd: undefined,
      },
      abstractRules: {
        content: [{ required: true, message: '简介内容必须填写', trigger: 'blur' }],
      }
    }
  },
  computed: {
  },
  methods: {
    nFieldChange(e, record) {
      record.n_field = e.target.value;
    },
    fieldMap(record) {
      this.$httpGet(`zserver/api/layer_fields?layer=${record.layer}`).then(res => {
        if (res && res.data) {
          this.fieldMapVisible = true;
          this.fieldMapData = res.data;
        }
      })
    },
    saveFieldMap() {
      this.$httpPut("zserver/api/layer_fields", this.fieldMapData).then(res => {
        if (res && res.data) {
          this.fieldMapVisible = false;
          this.fieldMapData = [];
          this.$message.success("保存成功");
        }
      })
    },
    onFieldShowChange(val, record) {
      record.show = val ? '1' : '-1';
    },
    saveHomeSetting() {
      this.$httpPost("zserver/api/home_setting", this.abstractForm).then(res => {
        if (res && res.data == 1) {
          this.$message.success("保存成功");
        }
      })
    },
    uploadAttach(record) {
      this.attachModalVisible = true;
      this.attachLayerKey = record.layer;
    },
    addAbstractHandle() {
      this.$refs.abstractForm.validate(valid => {
        if (valid) {
          if (this.abstractForm.id) {
            this.$httpPut("zserver/api/abstracts", this.abstractForm).then(res => {
              if (res.data) {
                this.abstractModalVisible = false;
                this.$refs.abstractForm.resetFields();
                this.$message.success("简介更新成功", 2);
                this.getAbstracts();
              }
            })
          } else {
            this.$httpPost("zserver/api/abstracts", this.abstractForm).then(res => {
              if (res.data) {
                this.abstractModalVisible = false;
                this.$refs.abstractForm.resetFields();
                this.$message.success("新增简介成功", 2);
                this.getAbstracts();
              }
            })
          }
        } else {
          return false;
        }
      })
    },
    cancelAbstractHandle() {
      this.$refs.abstractForm.resetFields();
      this.abstractForm["content"] = null;
    },
    deleteAbstract(record) {
      this.$httpDel(`zserver/api/abstracts/${record.id}`).then(res => {
        if (res) {
          this.$message.success("已删除", 2);
          this.getAbstracts();
        }
      })
    },
    editAbstract(record) {
      this.abstractModalVisible = true;
      for (let key in record) {
        this.abstractForm[key] = record[key];
      }
    },
    getAbstracts() {
      this.$httpGet("zserver/api/abstracts").then(res => {
        if (res.data) {
          this.abstractData = res.data;
        }
      })
    },
    setBaseMap(record) {
      this.$httpPut("zserver/api/layers", { id: record.key, is_basemap: record.is_basemap == "1" ? '-1' : '1' }).then((res) => {
        if (res) {
          this.getLayerTree();
        }
      })
    },
    logout() {
      dbTool.clear();
      this.$router.push("/login");
    },
    addRoleHandle() {
      this.$refs.roleForm.validate(valid => {
        if (valid) {
          if (this.roleForm.id) {
            this.$httpPut("zserver/api/roles", this.roleForm).then(res => {
              if (res.data) {
                this.roleModalVisible = false;
                this.$refs.roleForm.resetFields();
                this.$message.success("角色更新成功", 2);
                this.getRoles();
              }
            })
          } else {
            this.$httpPost("zserver/api/roles", this.roleForm).then(res => {
              if (res.data) {
                this.roleModalVisible = false;
                this.$refs.roleForm.resetFields();
                this.$message.success("新建角色成功", 2);
                this.getRoles();
              }
            })
          }
        } else {
          return false;
        }
      })
    },
    cancelRoleHandle() {
      this.$refs.roleForm.resetFields();
      for (let field in this.roleForm) {
        this.roleForm[field] = null;
      }
    },
    deleteRole(record) {
      this.$httpDel(`zserver/api/roles/${record.id}`).then(res => {
        if (res) {
          this.$message.success("已删除", 2);
          this.getRoles();
        }
      })
    },
    editRole(record) {
      this.roleModalVisible = true;
      for (let key in record) {
        this.roleForm[key] = record[key];
      }
    },
    nameRepeatValid(rule, value, callback) {
      this.dataData.forEach(node => {
        if (node.title == value) {
          callback(new Error(""));
          return;
        }
        if (node.type == "分组") {
          const children = node.children;
          children.forEach(child => {
            if (child.title == value) {
              callback(new Error(""));
              return;
            }
          })
        }
      })
      callback();
    },
    xyValid(rule, value, callback) {
      if (this.groupForm.type == "栅格" && !value) {
        callback(new Error('坐标必须填写'));
      } else {
        callback();
      }
    },
    validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('密码必须填写'));
      } else {
        if (this.userForm.checkPass !== '') {
          this.$refs.userForm.validateField('checkPass');
        }
        callback();
      }
    },
    validatePass2(rule, value, callback) {
      if (value === '') {
        callback(new Error('再次输入密码'));
      } else if (value !== this.userForm.password) {
        callback(new Error("两次密码不一致"));
      } else {
        callback();
      }
    },
    validateLoginExist(rule, value, callback) {
      if (value && !this.userForm.id) {
        // this.$httpGet(`zserver/api/user_exist/${value}`).then(res => {
        //   if (res.data === true) {
        //     callback(new Error('用户已存在'));
        //   } else {
        //     callback();
        //   }
        // })
        if (this.userData.filter(user => user.login == value).length > 0) {
          callback(new Error('用户已存在'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    cancelUserHandle() {
      this.$refs.userForm.resetFields();
      for (let field in this.userForm) {
        this.userForm[field] = null;
      }
    },
    addUserHandle() {
      this.$refs.userForm.validate(valid => {
        if (valid) {
          if (this.userForm.id) {
            this.$httpPut("zserver/api/users", this.userForm).then(res => {
              if (res.data) {
                this.userModalVisible = false;
                this.$refs.userForm.resetFields();
                this.$message.success("用户更新成功", 2);
                this.$httpGet("zserver/api/users").then(res => {
                  this.userData = res.data;
                })
              }
            })
          } else {
            this.$httpPost("zserver/api/users", this.userForm).then(res => {
              if (res.data) {
                this.userModalVisible = false;
                this.$refs.userForm.resetFields();
                this.$message.success("新建用户成功", 2);
                this.$httpGet("zserver/api/users").then(res => {
                  this.userData = res.data;
                })
              }
            })
          }
        } else {
          return false;
        }
      })
    },
    deleteUser(record) {
      if (record.login === "admin") {
        this.$message.warn("系统管理员禁止删除", 2);
        return;
      }
      this.$httpDel(`zserver/api/users/${record.id}`).then(res => {
        if (res) {
          this.$message.success("已删除", 2);
          this.$httpGet("zserver/api/users").then(res => {
            this.userData = res.data;
          })
        }
      })
    },
    editUser(record) {
      this.userModalVisible = true;
      for (let key in record) {
        this.userForm[key] = record[key];
      }
      this.userForm.checkPass = this.userForm.password;
    },
    setStyle(record) {
      this.$refs.styleSettingC.$emit("showThis", record);
    },
    uploadStatusChange(info) {
      this.uploadFileList = [...info.fileList].slice(-1);
      const status = info.file.status;
      if (status === 'done' && info.file.response.code == 100) {
        const resContent = info.file.response.content;
        this.groupForm.layer = resContent.name;
        this.groupForm.geometry_type = resContent.geometry_type;
        this.groupForm.bbox = resContent.bbox;
        this.groupForm.center = resContent.center;

      } else if (status === 'error') {
        this.$message.error(`${info.file.name}上传失败`);
      }
    },
    uploadAttachStatusChange(info) {
      const status = info.file.status;
      if (status === 'done') {
        this.$message.success("上传成功");
        this.attachModalVisible = false;
        this.attachLayerKey = "";
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}上传失败`);
      }
    },
    handleChange(value) {
      if (value === "分组") {
        this.layerNameLabel = "分组名称";
      } else {
        this.layerNameLabel = "图层名称";
      }

    },
    addLayer() {
      this.dataModalVisible = true;
      this.groupForm.id = null;
      this.groupForm.type = "分组";
      this.groupForm.bbox = "";
      this.groupForm.center = "";
      this.groupForm.layer = "";
      this.groupForm.geometry_type = "";
      this.uploadFileList = [];
    },
    editLayer(record) {
      this.dataModalVisible = true;
      this.groupForm.name = record.title;
      this.groupForm.type = record.type;
      this.groupForm.id = record.key;
      this.groupForm.group_id = undefined;
      this.layerNameLabel = "分组名称";
      if (record.type != "分组") {
        this.groupForm.bbox = record.bbox;
        this.groupForm.center = record.center;
        this.groupForm.layer = record.layer;
        this.groupForm.geometry_type = record.geometry_type;
        this.groupForm.group_id = record.group_id == "" ? undefined : record.group_id;
        this.layerNameLabel = "图层名称";
        if (this.isPngLayer(record.geometry_type)) {
          this.groupForm.leftX = JSON.parse(record.bbox)[0];
          this.groupForm.leftY = JSON.parse(record.bbox)[1];
          this.groupForm.rightX = JSON.parse(record.bbox)[2];
          this.groupForm.rightY = JSON.parse(record.bbox)[3];
        }
      }
    },
    addLayerHandle() {
      let self = this;
      this.$refs["groupForm"].validate(valid => {
        if (valid) {
          if (this.groupForm.type != "分组" && !this.groupForm.layer) {
            this.$message.warn("请先上传图层数据", 2);
            return;
          }
          if (this.isPngLayer(this.groupForm.geometry_type)) {
            this.groupForm.bbox = [parseFloat(this.groupForm.leftX), parseFloat(this.groupForm.leftY), parseFloat(this.groupForm.rightX), parseFloat(this.groupForm.rightY)];
            this.groupForm.center = [(parseFloat(this.groupForm.leftX) + parseFloat(this.groupForm.rightX)) / 2, [parseFloat(this.groupForm.leftY) + parseFloat(this.groupForm.rightY)] / 2];
          }
          if (this.groupForm.id) {
            this.$httpPut("zserver/api/layers", this.groupForm).then((res) => {
              self.dataModalVisible = false;
              if (res) {
                self.getLayerTree();
              }
            })
          } else {
            this.$httpPost("zserver/api/layers", this.groupForm).then((res) => {
              self.dataModalVisible = false;
              if (res) {
                self.getLayerTree();
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    deleteRow(record) {
      if (record.children && record.children.length > 0) {
        this.$message.warn("请先删除下级数据", 2);
        return;
      }
      this.$httpDel("zserver/api/layers/" + record.key).then(res => {
        if (res) {
          this.$message.success("已删除", 2);
          this.getLayerTree();
        }
      })
    },
    getFormat(format) {
      if (format === "polygon" || format === "point" || format === "line") {
        return "shp";
      }
      return format;
    },
    rowClick(record, index) {
      return {};
    },
    getLayerTree() {
      this.$httpGet("zserver/api/layers_tree").then(res => {
        this.dataData = res.data;
        this.groupNameOptions = this.dataData.filter(layer => layer.type === "分组").map(layer => {
          return { label: layer.title, value: layer.key };
        })
        this.groupNameOptions = [{ label: "取消分组", value: "" }, ...this.groupNameOptions];
        this.attrCanSearchLayerList = [];
        this.dataData.forEach(node => {
          if (node.type == "分组") {
            const children = node.children;
            children.forEach(child => {
              if (child.type == "矢量") {
                this.attrCanSearchLayerList.push({ label: child.title, value: child.layer });
              }
            })
          } else {
            if (node.type == "矢量") {
              this.attrCanSearchLayerList.push({ label: node.title, value: node.layer });
            }
          }
        })


      })
    },
    logPageChage(pagination) {
      if (this.logSearchParam.startTime && this.logSearchParam.endTime) {
        if (this.logSearchParam.startTime.valueOf() >= this.logSearchParam.endTime.valueOf()) {
          this.$message.warn("开始时间不能大于或等于结束时间!");
          return;
        }
      }
      let params = { pageNum: pagination.current, pageSize: pagination.pageSize, operation: this.logSearchParam.selectedLogOperation };
      if (this.logSearchParam.startTime) {
        params["start_time"] = this.logSearchParam.startTime.format("YYYY-MM-DD HH:mm:ss");

      }
      if (this.logSearchParam.endTime) {
        params["end_time"] = this.logSearchParam.endTime.format("YYYY-MM-DD HH:mm:ss");
      }
      this.getLogData(params);
    },
    getLogData(params) {
      this.$httpPost("zserver/api/logs", params).then(res => {
        if (res && res.data) {
          this.LogData = res.data.list;
          this.logPagination = {
            current: res.data.pageNum,
            pageSize: res.data.pageSize,
            total: res.data.total,
            hideOnSinglePage: true,
            // showQuickJumper: true
          }
        }
      })
    },
    resetLogParams() {
      this.logSearchParam.selectedLogOperation = undefined;
      this.logSearchParam.startTime = "";
      this.logSearchParam.endTime = "";
      this.getLogData({ pageNum: 1, pageSize: 10 });
    },
    searchLogs() {
      if (this.logSearchParam.startTime && this.logSearchParam.endTime) {
        if (this.logSearchParam.startTime.valueOf() >= this.logSearchParam.endTime.valueOf()) {
          this.$message.warn("开始时间不能大于或等于结束时间!");
          return;
        }
      }
      let params = { pageNum: 1, pageSize: 10, operation: this.logSearchParam.selectedLogOperation };
      if (this.logSearchParam.startTime) {
        params["start_time"] = this.logSearchParam.startTime.format("YYYY-MM-DD HH:mm:ss");

      }
      if (this.logSearchParam.endTime) {
        params["end_time"] = this.logSearchParam.endTime.format("YYYY-MM-DD HH:mm:ss");
      }
      this.getLogData(params);

    },
    tabChange(activeKey) {
      if (activeKey === "2") {
        this.$httpGet("zserver/api/users").then(res => {
          this.userData = res.data;
        })
      } else if (activeKey === "4") {
        // this.getAbstracts();
        this.getHomeSetting();

      } else if (activeKey === "5") {
        this.$httpGet("zserver/api/log_operation").then(res => {
          if (res && res.data) {
            this.operationOptions = res.data.map(op => {
              return { label: op, value: op };
            })
          }
        })
        this.resetLogParams();
      }
    },
    getHomeSetting() {
      this.$httpGet(`zserver/api/home_setting?orgNo=${this.$store.state.user.org_no}`).then(res => {
        if (res && res.data) {
          this.abstractForm.content = res.data["content"] || "";
          this.abstractForm.jbnt = res.data["jbnt"] || "";
          this.abstractForm.tdxz = res.data["tdxz"] || "";
          this.abstractForm.zllh = res.data["zllh"] || "";
          this.abstractForm.jjd = res.data["jjd"] || "";
        }
      })
    },
    getRoles() {
      this.$httpGet("zserver/api/roles").then(res => {
        if (res.data) {
          this.roleData = res.data;
          this.rolesOptions = res.data.map(role => {
            return { label: role.role_name, value: role.role_no };
          })
        }
      })
    },
    isPngLayer(ext) {
      if (".png".toLowerCase() == ext || ".jpg".toLowerCase() == ext || ".jpeg".toLowerCase() == ext) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.getLayerTree();
    this.getRoles();
  }
}
</script>
<style lang="scss" scoped>
.dd-layout {
  width: 100%;
  height: 100%;
  .ant-layout-header {
    background: rgba(13, 25, 68, 0.9);
    background-image: url("../assets/header_bg.png");
    background-size: 100% 100%;
    box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.35);
    & .dd-rowback {
      text-align: right;
      font-size: 18px;
      font-family: FZLanTingHei-R-GBK;
      font-weight: 400;
      color: #ffffff;
      & * {
        cursor: pointer;
      }
    }
  }
}
</style>
<style lang="scss">
.dd-tabs {
  .ant-tabs-tab {
    background: rgba(13, 25, 68, 0.1) !important;
    height: 55px !important;
    border: none !important;
    line-height: 55px !important;
    text-align: left !important;
    font-size: 16px !important;
    font-family: FZLanTingHei-DB-GBK !important;
    font-weight: 400 !important;
    color: #9a9ca3 !important;
  }
  .ant-tabs-tab-active {
    background: #ffffff !important;
  }
  .ant-tabs-content {
    min-height: 500px;
    background: #fff;
    padding: 15px 20px;
  }
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 8px 16px;
    overflow-wrap: break-word;
    font-family: FZLanTingHei-DB-GBK;
    font-weight: 400;
    word-break: break-all;
  }
  .ant-table-thead {
    th {
      background: rgba(13, 25, 68, 0.1);
      font-family: FZLanTingHei-DB-GBK;
      font-weight: 400;
      color: #3a3a3a;
    }
  }
  .ant-radio-button-wrapper-checked {
    background: #00bb59 !important;
    border-color: #00bb59 !important;
  }
}
.m-colorPicker {
  top: 2px !important;
}
.ant-row {
  margin-bottom: 5px;
}
</style>